<template>
  <div class="charge-mode-card" @click="oClick" :class="{'active':checked}"  :style="dymicStyle">
    <div class="info-container">
      <div class="title">{{  props.title }}</div>
      <div class="sub-title">{{ props.subtitle }}</div>
    </div>
    <div class="check-symbol">
      <el-icon class="check-icon"><Check /></el-icon>
    </div>
  </div>
</template>

<script setup>

import {computed, inject, reactive} from "vue"
import { Check } from "@element-plus/icons-vue";
const $str = window.$str;

const props = defineProps(['title', 'subtitle', 'value', 'color'])
const onChange = inject('onChange')
const currentValue = inject('currentValue')
const checked = computed(() => {
  return currentValue.value == props.value
})

const dymicStyle = reactive({
  '--color': props.color,
  '--bk-color': `${props.color}33`,
})

function oClick() {
  onChange && onChange(props.value)
}

</script>

<style lang="scss" scoped>
.charge-mode-card {
  height: 95px;
  padding: 16px 22px;
  margin: 20px 0;
  background: #FFFFFF;

  border-radius: 10px;
  border-width: 1px 1px 1px 6px;
  border-style: solid;
  border-color: transparent transparent transparent var(--color);


  display: flex;
  justify-content: space-between;
  align-items: center;
  &.active {
    border-color: var(--color);
    background-image: linear-gradient(to right, var(--bk-color) 0%, #FFFFFF 66%);

    .check-symbol {
      background: var(--color);
      .check-icon {
        visibility: visible;
      }
    }
  }
  .info-container {
    display: flex;
    flex-direction: column;
    gap: 6px;
    .title {
      font-family: PingFang-SC, PingFang-SC;
      font-weight: bold;
      font-size: 16px;
      color: #2E2E2E;
    }
    .sub-title {
      font-family: PingFang-SC, PingFang-SC;
      font-weight: 500;
      font-size: 14px;
      color: #2E2E2E99;
    }
  }

  .check-symbol {
    width: 26px;
    height: 26px;
    border: 2px solid #E0E4E7;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    .check-icon {
      width: 100%;
      height: 100%;
      font-size: 18px;
      font-weight: bold;
      color: #fff;
      visibility: hidden;
    }
  }
}
</style>
